import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomeView.vue'
import Perso from '../views/PersoView.vue'
import Blog from '../views/BlogView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/perso',
    name: 'Perso',
    component: Perso
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
